module.exports = __webpack_public_path__ + "static/media/quienes_somos.597d031d.jpg";